import { render } from "./AccountManagement.vue?vue&type=template&id=c8a15eb4&scoped=true"
import script from "./AccountManagement.vue?vue&type=script&lang=js"
export * from "./AccountManagement.vue?vue&type=script&lang=js"

import "./AccountManagement.vue?vue&type=style&index=0&id=c8a15eb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a15eb4"]])

export default __exports__